// Module
var code = "<react-component name=\"ArchivedWorkoutsList\"></react-component>\n";
// Exports
module.exports = code;